var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v(_vm._s(_vm.$t('404.page_not_found')))]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('button.home')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }